import React from "react";
import { useTranslation } from "react-i18next";

const PetProfileView = ({ petData, handleEditSection, isOwner = false }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  
  const basicFields = [
    { key: "name", label: t("petProfileView.fields.name"), value: petData.name || t("petProfileView.values.notSpecified") },
    { key: "color", label: t("petProfileView.fields.color"), value: petData.color || t("petProfileView.values.notSpecified") },
    { key: "species", label: t("petProfileView.fields.species"), value: typeof petData.species === 'object' && petData.species?.name ? petData.species.name : (petData.species || t("petProfileView.values.unknown")) },
    { key: "gender", label: t("petProfileView.fields.gender"), value: petData.gender ? (petData.gender.toLowerCase() === "male" ? t("petProfileView.values.male") : petData.gender.toLowerCase() === "female" ? t("petProfileView.values.female") : petData.gender) : t("petProfileView.values.notSpecified") },
    { key: "breed", label: t("petProfileView.fields.breed"), value: typeof petData.breed === 'object' && petData.breed?.name ? petData.breed.name : (petData.breed || t("petProfileView.values.notSpecified")) },
    { key: "age", label: t("petProfileView.fields.age"), value: petData.age || t("petProfileView.values.notSpecified") },
    { key: "weight", label: t("petProfileView.fields.weight"), value: petData.weight || t("petProfileView.values.notSpecified") },
  ];

  const otherFields = [
    { key: "microchipId", label: t("petProfileView.fields.microchipId"), value: petData.microchipId || t("petProfileView.values.notSpecified") },
    { key: "smartCollarId", label: t("petProfileView.fields.smartCollarId"), value: petData.smartCollarId || t("petProfileView.values.notSpecified") },
    { key: "spayedNeutered", label: t("petProfileView.fields.spayedNeutered"), value: petData.spayedNeutered || t("petProfileView.values.notSpecified") },
    { key: "provider", label: t("petProfileView.fields.provider"), value: petData.provider || t("petProfileView.values.notSpecified") },
    { key: "providerNumber", label: t("petProfileView.fields.providerNumber"), value: petData.providerNumber || t("petProfileView.values.notSpecified") },
  ];

  const renderSection = (title, fields, sectionKey) => (
    <div
      style={{
        background: "#FFFFFF",
        borderRadius: "12px",
        padding: "24px",
        border: "1px solid #E5E7EB",
        marginBottom: "24px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          paddingBottom: "12px",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <h3
          style={{
            fontFamily: '"Red Hat Display", sans-serif',
            fontSize: "20px",
            fontWeight: 600,
            color: "#1F2937",
            margin: 0,
          }}
        >
          {title}
        </h3>
        {isOwner && (
          <button
            onClick={() => handleEditSection(sectionKey)}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "4px 8px",
              color: "#6B7280",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "14px",
            }}
            onMouseEnter={(e) => {
              e.target.style.color = "#374151";
            }}
            onMouseLeave={(e) => {
              e.target.style.color = "#6B7280";
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            {t("petProfileView.edit")}
          </button>
        )}
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "16px",
          direction: isRTL ? "rtl" : "ltr",
        }}
      >
        {fields.map((field) => (
          <div
            key={field.key}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <span
              style={{
                fontSize: "13px",
                color: "#6B7280",
                fontWeight: 500,
              }}
            >
              {field.label}
            </span>
            <span
              style={{
                fontSize: "16px",
                color: "#1F2937",
                fontWeight: 500,
              }}
            >
              {field.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 20px",
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      {renderSection(t("petProfileView.basicInformation"), basicFields, "basic")}
      {renderSection(t("petProfileView.otherInformation"), otherFields, "other")}
    </div>
  );
};

export default PetProfileView;
